import React from "react";
import PropTypes from "prop-types";

// Material imports
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { MultipleChoiceQuizTemplate, QuizTryAgainSuccess } from "@limitless/content";
import { usePageViewRecorder } from "@limitless/analytics";

const useStyles = makeStyles(() => ({
    closeContainer: {
        textAlign: "right",
        padding: 0
    },
    contentContainer: {
        padding: "0px 32px 32px 32px"
    },
    dialogContainer: {
        maxWidth: 660,
        borderRadius: 8
    }
}));

export const ExpertMultiChoiceQuizDialog = ({
    open,
    handleCloseDailog,
    quizTryAgainSuccessContent,
    onboardingMcQuizContent,
    quizState,
    handleQuizTryAgainSuccessClick,
    updateSelectedAnswer,
    isAllowToSubmitAnswers,
    submitQuiz
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    usePageViewRecorder("Onboarding - Multiple Choice Quiz");

    return (
        <Dialog fullWidth open={open} onClose={handleCloseDailog} classes={{ paperWidthSm: classes.dialogContainer }}>
            <DialogTitle className={classes.closeContainer}>
                <IconButton aria-label="close button" onClick={handleCloseDailog} size="large">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.contentContainer}>
                {Object.keys(quizTryAgainSuccessContent).length !== 0 ? (
                    <QuizTryAgainSuccess
                        quizAttemptsLeft={quizState.quizAttemptsLeft}
                        content={quizTryAgainSuccessContent}
                        t={t}
                        buttonClick={handleQuizTryAgainSuccessClick}
                    />
                ) : onboardingMcQuizContent.template ? (
                    <MultipleChoiceQuizTemplate
                        content={onboardingMcQuizContent}
                        quizState={quizState}
                        quizCtaClick={submitQuiz}
                        disableQuizCta={isAllowToSubmitAnswers()}
                        handleAnswerChange={(index, sectionIndex) => {
                            updateSelectedAnswer(parseInt(index), sectionIndex);
                        }}
                    />
                ) : (
                    <div />
                )}
            </DialogContent>
        </Dialog>
    );
};

ExpertMultiChoiceQuizDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleCloseDailog: PropTypes.func.isRequired,
    quizTryAgainSuccessContent: PropTypes.object.isRequired,
    onboardingMcQuizContent: PropTypes.object.isRequired,
    handleQuizTryAgainSuccessClick: PropTypes.func.isRequired,
    updateSelectedAnswer: PropTypes.func.isRequired,
    isAllowToSubmitAnswers: PropTypes.func.isRequired,
    submitQuiz: PropTypes.func.isRequired,
    quizState: PropTypes.object.isRequired
};